import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Model, Vehicle } from 'src/app/core/interfaces/vehicle';
import { StateUserPipe } from 'src/app/core/pipe/stateInactive.pipe';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { VehiclesService } from '../list-vehicles.service';
import { AuthService } from 'src/app/core/services/authentication.service';
import { User } from 'src/app/core/interfaces/user';
import { AdminUsersService } from '../../admin-users/admin-users.service';
import { Utils } from 'src/app/core/resources/utils';
import { NgxSpinnerService } from 'ngx-spinner';
import { RelatedInfoUser } from 'src/app/core/interfaces/relatedInfoUser';
import { ValidationRule } from 'src/app/core/interfaces/validation-rule';
import { ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { TitleCasePipe } from '@angular/common';
import { DateManager } from 'src/app/core/managers/date.manager';
import { DateEnum } from 'src/app/core/enums/date.enum';
import { FormGroup } from '@angular/forms';
import { OpenImgComponent } from 'src/app/shared/open-img/open-img.component';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Permission } from 'src/app/core/resources/permission';
@Component({
    selector: 'app-security-card',
    templateUrl: './security-card.component.html',
    styleUrls: ['./security-card.component.scss'],
    providers: [TitleCasePipe]
})
export class SecurityCardComponent implements OnInit {

    @Input() messageInactive: string;
    @Input() vehicle: Vehicle;
    @Input() driver: User;
    @Input() owner: User;
    @Input() administrator: User;
    @Input() relatedInfoDriver: RelatedInfoUser;
    @Input() relatedInfoOwner: RelatedInfoUser;
    @Input() relatedInfoAdministrator: RelatedInfoUser;
    @Output() onEdit: EventEmitter<string> = new EventEmitter<string>();


    registrationDate?: string;
    remainingTime: number = 0;
    intervalId: any;

    countdowns: { [key: string]: number } = { vehicle: 0, owner: 0, admin: 0, driver: 0 };
    countdownIntervals: { [key: string]: any } = { vehicle: null, owner: null, admin: null, driver: null };
    userStatus: { [key: string]: boolean } = { vehicle: false, owner: false, admin: false, driver: false };
    private modalOpen: { [key: string]: boolean } = {
        vehicle: false,
        driver: false,
        owner: false,
        admin: false
    };
    studyCards = [
        { name: 'Vehicle', alias: 'vehículo', value: 'vehicle', show: 'id' },
        { name: 'Driver', alias: 'conductor', value: 'driver', show: 'driver' },
        { name: 'Owner', alias: 'propietario', value: 'owner', show: 'owner' },
        { name: 'Admin', alias: 'administrador', value: 'admin', show: 'administrator' },
    ]

    allowCreatingWithoutTruora: boolean = false;
    docRules: Array<ValidationRule>;

    readonly MAX_COUNTDOWN_MINUTES = 15;
    readonly MILLISECONDS_PER_SECOND = 1000;
    readonly SECONDS_PER_MINUTE = 60;

    securityStudiesEnabled: boolean = false;
    isStudyGenerated: boolean = false;

    constructor(
        private stateUserPipe: StateUserPipe,
        private snackBarService: SnackBarService,
        private authService: AuthService,
        private vehiclesService: VehiclesService,
        private adminUserService: AdminUsersService,
        private utils: Utils,
        private spinner: NgxSpinnerService,
        private dialog: MatDialog,
        private titleCasePipe: TitleCasePipe,
        public modelVehicle: Model,
        private permissionRole: PermissionRole,

    ) { }

    async ngOnInit() {
        await this.checkSecurityConfiguration();
        this.checkSecurityStudiesEnabled();
    }

    canVisualizeStudyCard(property: string): boolean {
        return this.vehicle && this.utils.getNestedValue(this.vehicle, property);
    }


    private async confirmNewStudy(): Promise<boolean> {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            title: 'La generación de un nuevo estudio de seguridad tiene un costo adicional. ¿Deseas continuar?',
            showBtnConfirmObservation: true
        };
        dialogConfig.maxHeight = ModalEnum.MEDIUM_HEIGHT;
        dialogConfig.maxWidth = ModalEnum.EXTRA_SMALL_WIDTH;
        dialogConfig.autoFocus = false;
        dialogConfig.disableClose = true;
        const response = await this.dialog.open(DialogComponent, dialogConfig).afterClosed().toPromise();
        return response && response.refuse;
    }

    async openSecurityStudy(type: 'Driver' | 'Owner' | 'Admin' | 'Vehicle') {
        if (!this.hasPermissionToManageSecurityStudy) return;
        const confirm = await this.confirmNewStudy();
        if (!confirm) return;
        const typeKey = type.toLowerCase() as 'driver' | 'owner' | 'admin' | 'vehicle';
        this.modalOpen[typeKey] = true;
        this.startSecurityStudy(type);
        this.modalOpen[typeKey] = false;
    }

    async openSecurityStudyVehicleAndDriver() {
        if (!this.hasPermissionToManageSecurityStudy) return;
        const confirm = await this.confirmNewStudy();
        if (!confirm) return;
        const form: FormGroup = this.utils.createFormGroupFromObject(this.modelVehicle.modelCreate);
        form.get('vehicle').patchValue(this.vehicle);
        form.get('driver').patchValue(this.driver);
        if (this.vehicle.owner) form.get('owner').patchValue(this.owner);
        if (this.vehicle.administrator) form.get('administrator').patchValue(this.administrator);
        const data = form.getRawValue();
        if (!this.vehicle.owner) delete data.owner;
        if (!this.vehicle.administrator) delete data.administrator;
        data['validateTruora'] = true;
        data['forceCreation'] = true;
        if (this.vehicle.fleetLoyaltyCategory) data.vehicle['fleetLoyaltyCategory'] = this.vehicle.fleetLoyaltyCategory;
        this.spinner.show();
        this.vehiclesService.createVehicleDriverOwner(data).subscribe({
            next: () => {
                this.snackBarService.openSnackBar('Validación en proceso');
                this.onEdit.emit(this.vehicle.id);
                this.spinner.hide();
            },
            error: () => {
                this.snackBarService.openSnackBar('Ocurrio un error al generar el estudio de seguridad', undefined, 'error');
                this.spinner.hide();
            }
        })
    }

    async checkSecurityConfiguration() {
        try {
            const companySaaS = this.authService.getCompanySaaS();
            this.allowCreatingWithoutTruora = companySaaS.allowCreatingWithoutTruora;
            this.docRules = await this.vehiclesService.getValidationRules().toPromise();
        } catch (error) {
            this.snackBarService.openSnackBar(
                'Error al verificar la configuración de seguridad',
                undefined,
                'error'
            );
        }
    }

    initialCountdownIndividual(type: 'vehicle' | 'owner' | 'admin' | 'driver') {
        const date: string = this.utils.getNestedValue(this[type], 'truora.requestedBy.date');
        if (typeof date === 'string') {
            this.initializeCountdown(type, date);
        }
    }

    initializeCountdown(type: 'driver' | 'owner' | 'admin' | 'vehicle', date: string) {
        if (date) {
            const now = new Date();
            const requestDateTime = DateManager.stringToDate(this.utils.clone(date), DateEnum.YYYY_MM_DD_HH_mm_ZZ);
            const maxSeconds = this.MAX_COUNTDOWN_MINUTES * this.SECONDS_PER_MINUTE;
            const diffInSeconds = DateManager.dateDiff(now, null, requestDateTime, null, "seconds");
            const remainingSeconds = maxSeconds - diffInSeconds;
            const getStudyStatus = this.getStudyStatus(this.titleCasePipe.transform(type) as 'Driver' | 'Owner' | 'Admin' | 'Vehicle');
            if (remainingSeconds > 0 && getStudyStatus.status === 'En Proceso' && (!this.countdowns[type] || remainingSeconds > this.countdowns[type])) {
                this.startCountdown(type, remainingSeconds);
            } else if (getStudyStatus.status !== 'En Proceso' && this.countdowns[type] > 0) {
                this.stopCountdown(type);
            }
        }
    }

    async ngOnChanges(changes: SimpleChanges) {
        if (changes['vehicle'] && (!changes['vehicle'].previousValue || JSON.stringify(changes['vehicle'].currentValue) !== JSON.stringify(changes['vehicle'].previousValue))) {
            this.userStatus.vehicle = this.vehicle && this.vehicle.state && this.vehicle.state.active;
            this.initialCountdownIndividual('vehicle');
        }
        if (changes['owner'] && (!changes['owner'].previousValue || JSON.stringify(changes['owner'].currentValue) !== JSON.stringify(changes['owner'].previousValue))) {
            const ownerState = await this.adminUserService.getUserStateByValidationRules(this.owner, 'Owner');
            this.userStatus.owner = ownerState && ownerState.active;
            this.initialCountdownIndividual('owner');
        }
        if (changes['administrator'] && (!changes['administrator'].previousValue || JSON.stringify(changes['administrator'].currentValue) !== JSON.stringify(changes['administrator'].previousValue))) {
            const adminState = await this.adminUserService.getUserStateByValidationRules(this.administrator, 'Admin');
            this.userStatus.admin = adminState && adminState.active;
            this.initialCountdownIndividual('admin');
        }
        if (changes['driver'] && (!changes['driver'].previousValue || JSON.stringify(changes['driver'].currentValue) !== JSON.stringify(changes['driver'].previousValue))) {
            const driverState = await this.adminUserService.getUserStateByValidationRules(this.driver, 'Driver');
            this.userStatus.driver = driverState && driverState.active;
            this.initialCountdownIndividual('driver');
        }
    }

    startCountdown(type: 'driver' | 'owner' | 'admin' | 'vehicle', currentSeconds: number) {

        if (this.countdownIntervals[type]) clearInterval(this.countdownIntervals[type]);
        this.countdowns[type] = currentSeconds;
        this.countdownIntervals[type] = setInterval(() => {
            if (this.countdowns[type] > 0) this.countdowns[type]--;
            else this.stopCountdown(type);
        }, this.MILLISECONDS_PER_SECOND);
    }

    stopCountdown(type: 'driver' | 'owner' | 'admin' | 'vehicle') {
        if (this.countdownIntervals[type]) {
            clearInterval(this.countdownIntervals[type]);
            this.countdownIntervals[type] = null;
        } this.countdowns[type] = 0;
    }

    private getValidationRule(type: 'Driver' | 'Owner' | 'Admin'): boolean {
        if (!this.docRules || this.docRules.length === 0) return false;
        return this.docRules.some(rule => rule && rule.roleName === type && rule.ruleType === 'security' && rule.active);
    }

    getFormattedCountdown(type: string): string {
        const minutes = Math.floor(this.countdowns[type] / this.SECONDS_PER_MINUTE);
        const seconds = this.countdowns[type] % this.SECONDS_PER_MINUTE;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }

    public isEnabledSecurityStudy(type: 'Driver' | 'Owner' | 'Admin' | 'Vehicle'): boolean {
        const validationRule = type === 'Vehicle' ? true : this.getValidationRule(type);
        return !!validationRule;
    }

    public async startSecurityStudy(type: 'Driver' | 'Owner' | 'Admin' | 'Vehicle') {
        if (this.allowCreatingWithoutTruora) return;
        const isEnabled = this.isEnabledSecurityStudy(type);
        if (!isEnabled) return;
        try {
            if (!this.vehicle || !this.vehicle.id) return this.snackBarService.openSnackBar('Vehículo no válido', undefined, 'error');
            if (type === 'Vehicle') this.checkValidateVehicle();
            else this.checkValidationIndividual(type);
        } catch (error) { this.snackBarService.openSnackBar('Error al iniciar el estudio de seguridad', undefined, 'error'); }
    }

    private checkValidationIndividual(type: 'Owner' | 'Admin' | 'Driver'): void {
        const user: User = type === 'Owner' ? this.utils.clone(this.owner) : type === 'Admin' ? this.utils.clone(this.administrator) : this.utils.clone(this.driver);
        delete user.profilePictureUrl;
        const userDocument = this.utils.getNestedValue(user, 'information.document');
        if (!userDocument) return this.snackBarService.openSnackBar(' No se pudo obtener el documento del usuario', undefined, 'error');
        this.spinner.show();
        this.adminUserService.checkValidationIndividual(user).subscribe({
            next: () => {
                this.snackBarService.openSnackBar('Validación en proceso');
                this.onEdit.emit(this.vehicle.id);
                this.spinner.hide();
            },
            error: () => {
                this.snackBarService.openSnackBar('Ocurrio un error al generar el estudio de seguridad', undefined, 'error');
                this.spinner.hide();
            }
        })
    }
    /**
     * @param {boolean} forceCreation indicates if the vehicle must to be created if doesn't exist or not
     * @description Sends a validation to check the vehicle state
     */
    checkValidateVehicle() {
        this.spinner.show();
        this.vehiclesService.basicCheck(this.vehicle.id).toPromise()
            .then(() => {
                this.snackBarService.openSnackBar("Validación en proceso");
            })
            .catch(() => this.snackBarService.openSnackBar("Ocurrio un error al generar el estudio de seguridad", undefined, "error"))
            .finally(() => {
                this.onEdit.emit(this.vehicle.id);
                this.spinner.hide();
            });
    }




    /**
  * @description Copies a message of vehicle, driver, owner and vehicle's state
  */
    copyMessage() {
        const selBox = document.createElement("textarea");
        selBox.style.position = "fixed";
        selBox.style.left = "0";
        selBox.style.top = "0";
        selBox.style.opacity = "0";
        selBox.value = `Mensaje: ${this.stateUserPipe.transform(
            this.vehicle.state.description
        )} - Vehiculo: ${this.vehicle.id} - Conductor: ${this.vehicle.driver.document
            } - Propietario: ${this.vehicle.owner.document}`;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand("copy");
        document.body.removeChild(selBox);
        if (selBox.value != "") this.snackBarService.openSnackBar("Texto copiado al portapapeles", undefined, "success");
    }

    private isSecurityStudyInProgress(user: any): boolean {
        return user && user.state && !user.state.active && user.state.description === 'Pending';
    }

    private isSecurityStudyReason(user: User | Vehicle): boolean {
        return !!(user && user.truora && user.truora.reason);
    }

    private hasStatusError(entity: User | Vehicle): string {
        if (!entity || !entity.statusesSecurityValidation || entity.statusesSecurityValidation.length === 0) return '';
        const status = entity.statusesSecurityValidation.find(status => status && status.status && status.status.includes('not_found'));
        return status ? status.databaseName : '';
    }

    private hasTruoraSignals(entity: User | Vehicle): boolean {
        const requested = this.utils.getNestedValue(entity, 'truora.requestedBy.date');
        const checkId = this.utils.getNestedValue(entity, 'truora.checkId');
        return !!(requested || checkId);
    }

    getStudyStatus(type: 'Driver' | 'Owner' | 'Admin' | 'Vehicle') {
        const user = type === 'Driver' ? this.driver : type === 'Owner' ? this.owner : type === 'Admin' ? this.administrator : this.vehicle;
        const roles = type === 'Driver' ? 'conductor' : type === 'Owner' ? 'propietario' : type === 'Admin' ? 'administrador' : 'vehículo';
        const isEnabled = this.isEnabledSecurityStudy(type);
        if (!isEnabled) return { status: 'No habilitado', message: `Los estudios de seguridad no están habilitados para el ${roles}`, color: 'circle-gray' };
        if (this.isSecurityStudyInProgress(user)) return { status: 'En Proceso', message: `En proceso`, color: 'circle-yellow' };
        const statusError = this.hasStatusError(user);
        if (statusError) return { status: 'Finalizado con datos incompletos', message: `Finalizado con datos incompletos, (${statusError})`, color: 'circle-red' };
        if (this.isSecurityStudyReason(user)) return { status: 'Finalizado con datos incompletos', message: `Finalizado con datos incompletos, (${user.truora.reason})`, color: 'circle-red' };
        if (this.isStudyComplete(type)) return { status: 'Finalizado y Completo', message: `Finalizado y completado`, color: 'circle-green' };
        if (!this.hasTruoraSignals(user)) {
            return { status: 'Sin estudio', message: 'No fue posible generar estudio de seguridad', color: 'circle-gray' };
        }
        return {
            status: 'Finalizado con datos incompletos',
            message: `Finalizado con datos incompletos, (falla de base de datos externa)`,
            color: 'circle-red'
        };
    }

    getPdfIconClass(type: 'Driver' | 'Owner' | 'Admin' | 'Vehicle'): string {
        const studyStatus = this.getStudyStatus(type);
        const colorMapping: { [key: string]: string } = {
            'circle-green': 'pdf-green',
            'circle-red': 'pdf-red',
            'circle-yellow': 'pdf-yellow',
            'circle-gray': 'pdf-gray'
        };
        return colorMapping[studyStatus.color] || 'pdf-gray';
    }

    canVisualizeTypeAndPdf(type: 'Driver' | 'Owner' | 'Admin' | 'Vehicle'): boolean {
        const studyStatus = this.getStudyStatus(type);
        return ['Finalizado y Completo', 'Finalizado con datos incompletos'].includes(studyStatus.status);
    }

    private isStudyComplete(type: 'Driver' | 'Owner' | 'Admin' | 'Vehicle'): boolean {
        return this.userStatus[type.toLowerCase()];
    }



    hasActiveStudies(): boolean {
        return (this.countdowns['vehicle'] > 0 || this.countdowns['owner'] > 0 || this.countdowns['admin'] > 0 || this.countdowns['driver'] > 0);
    }

    isAnyStudyInProgress(): boolean {
        return (this.countdowns['vehicle'] > 0 || this.countdowns['owner'] > 0 || this.countdowns['admin'] > 0 || this.countdowns['driver'] > 0);
    }


    isSpecificStudyInProgress(type: 'Driver' | 'Owner' | 'Admin' | 'Vehicle'): boolean {
        const typeKey = type.toLowerCase() as 'driver' | 'owner' | 'admin' | 'vehicle';
        return this.countdowns[typeKey] > 0 || this.modalOpen[typeKey];
    }

    hasStatePending(type: 'Driver' | 'Owner' | 'Admin' | 'Vehicle'): boolean {
        const user = type === 'Driver' ? this.driver : type === 'Owner' ? this.owner : type === 'Admin' ? this.administrator : this.vehicle;
        return user && user.state && user.state.description === 'Pending';
    }

    showStatus(role: 'Driver' | 'Owner' | 'Admin' | 'Vehicle'): boolean {
        const status = this.getStudyStatus(role).status;
        return status !== 'idle';
    }

    private checkSecurityStudiesEnabled() {
        try {
            const companySaaS = this.authService.getCompanySaaS();
            this.securityStudiesEnabled = !companySaaS.allowCreatingWithoutTruora;
        } catch (error) { this.securityStudiesEnabled = false; }
    }

    get admin() {
        return this.administrator ? this.administrator : null;
    }


    getCheckId(type: 'Driver' | 'Owner' | 'Admin' | 'Vehicle'): string {
        const entity = type === 'Driver' ? this.driver : type === 'Owner' ? this.owner : type === 'Admin' ? this.administrator : this.vehicle;
        return this.utils.getNestedValue(entity, 'truora.checkId');
    }

    async visualizePDF(type: 'Driver' | 'Owner' | 'Admin' | 'Vehicle') {
        const checkId = this.getCheckId(type);
        this.spinner.show();
        let response: Object = null;
        try {
            response = await this.adminUserService.getPDFTruora(checkId).toPromise();
        } catch (error) { }
        this.spinner.hide();
        if (response && response["report_url"]) {
            const url = new URL(response["report_url"]);
            if (url) return this.openPreviewPDF(url);
        }
        this.snackBarService.openSnackBar("Ocurrió un error al traer el PDF", undefined, "error");
    }

    private openPreviewPDF(url: URL) {
        const params: any = {
            title: "Análisis de seguridad",
            src: url,
        };
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = params;
        dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
        dialogConfig.width = ModalEnum.LARGE_WIDTH;
        dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
        dialogConfig.autoFocus = false;
        this.dialog.open(OpenImgComponent, dialogConfig);
    }

    isStudyConjoined(type: 'Driver' | 'Owner' | 'Admin' | 'Vehicle') {
        const driverCheckId = this.utils.getNestedValue(this.driver, 'truora.checkId');
        const vehicleCheckId = this.utils.getNestedValue(this.vehicle, 'truora.checkId');
        if (driverCheckId && vehicleCheckId && driverCheckId === vehicleCheckId && ['Driver', 'Vehicle'].includes(type)) return { class: 'alert-info', message: 'Estudio de seguridad en conjunto', isConjoined: true };
        return { class: 'alert-info', message: 'Estudio de seguridad independiente', isConjoined: false };
    }

    finalizeStudyTruora(type: 'Driver' | 'Owner' | 'Admin' | 'Vehicle') {
        if (!this.hasPermissionToManageSecurityStudy) return;
        const isConjoined = ['Driver', 'Vehicle'].includes(type) && this.isStudyConjoined(type).isConjoined && this.hasStatePending('Driver') && this.hasStatePending('Vehicle');
        const document = type === 'Driver' || isConjoined ? this.driver.information.document : type === 'Owner' ? this.owner.information.document : type === 'Admin' ? this.administrator.information.document : null;
        this.spinner.show();
        this.adminUserService.finalizeStudyTruora(document, type === 'Vehicle' || isConjoined ? this.vehicle.id : null).subscribe({
            next: () => {
                this.snackBarService.openSnackBar('Estudio de seguridad finalizado');
                this.spinner.hide();
            },
            error: () => {
                this.snackBarService.openSnackBar('Ocurrio un error al finalizar el estudio de seguridad', undefined, 'error');
                this.spinner.hide();
            }
        })
    }

    getStudyDate(type: 'Driver' | 'Owner' | 'Admin' | 'Vehicle'): string {
        const user = type === 'Driver' ? this.driver : type === 'Owner' ? this.owner : type === 'Admin' ? this.administrator : this.vehicle;
        const date: string = this.utils.getNestedValue(user, 'truora.requestedBy.date');
        if (!date) return '';
        const requestDateTime = DateManager.stringToDate(date, DateEnum.YYYY_MM_DD_HH_mm_ZZ);
        return DateManager.dateToString(requestDateTime, 'DD/MM/YYYY HH:mm');
    }

    getExpeditionDate(type: 'Driver' | 'Owner' | 'Admin' | 'Vehicle'): string {
        const user = type === 'Driver' ? this.driver : type === 'Owner' ? this.owner : type === 'Admin' ? this.administrator : this.vehicle;
        const date: string = this.utils.getNestedValue(user, 'truora.checkExpeditionDate');
        if (!date) return '';
        const expeditionDate = DateManager.stringToDate(date, 'DD/MM/YYYY');
        return DateManager.dateToString(expeditionDate, 'DD/MM/YYYY');
    }

    get hasPermissionToManageSecurityStudy(): boolean {
        return this.permissionRole.hasPermission(
            Permission.administration.module,
            Permission.administration.manageSecurityStudy
        );
    }

    readonly missingSecurityStudyPermissionTooltip =
        'No cuentas con el permiso: Generar y finalizar estudios de seguridad.';
}